'use client'

import { useFieldArray, useFormContext } from 'react-hook-form'
import { Divider } from '@vinted/web-ui'

import { DocumentFieldConfigurationModel } from '@marketplace-web/pay-identity/payments-identity-data'
import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'
import { KybFormFields, KybFormModel } from '@marketplace-web/pay-identity/pay-identity-kyc-data'

import SupportingDocument from './SupportingDocument'

type Props = {
  isFormDisabled: boolean
  supportingDocumentsConfiguration?: Array<DocumentFieldConfigurationModel>
}

const SupportingDocuments = ({ isFormDisabled, supportingDocumentsConfiguration }: Props) => {
  const { control } = useFormContext<KybFormModel>()

  const { fields } = useFieldArray({
    control,
    name: KybFormFields.SupportingDocuments,
  })

  const getFieldConfiguration = (fieldName: string) => {
    return supportingDocumentsConfiguration?.find(
      configuration => configuration.options[0]!.type === fieldName,
    )
  }

  if (!supportingDocumentsConfiguration) return null

  return (
    <SeparatedList separator={<Divider />}>
      {fields.map((field, index) => {
        const fieldConfig = getFieldConfiguration(field.type)

        const optionConfig = fieldConfig?.options?.[0]

        if (!optionConfig) return null

        return (
          <SupportingDocument
            key={field.id}
            index={index}
            title={optionConfig.title}
            mediaTypes={optionConfig.mediaTypes}
            maximumFileSize={optionConfig.maximumFileSize}
            type={field.type}
            isDisabled={isFormDisabled}
            info={fieldConfig?.info}
          />
        )
      })}
    </SeparatedList>
  )
}

export default SupportingDocuments
